module.exports = __webpack_public_path__ + "img/background.aef3963b.jpg";